import Vue from "vue";
import Router from "vue-router";
const register = resolve => require(["@/views/register.vue"], resolve);
const home = resolve => require(["@/views/home.vue"], resolve);
const index = resolve => require(["@/views/index.vue"], resolve);
const agreement = resolve => require(["@/views/agreement.vue"], resolve);
const notFound = resolve => require(["@/views/notFound.vue"], resolve);
const mineVoucher = resolve => require(["@/views/mine/voucher.vue"], resolve);
const doneOrder = resolve => require(["@/views/order/done.vue"], resolve);
const orderDetail = resolve => require(["@/views/order/detail.vue"], resolve);
const scorePage = resolve => require(["@/views/order/score.vue"], resolve);
const useVoucher = resolve => require(["@/views/voucher/use.vue"], resolve);
const voucherExplain = resolve =>
  require(["@/views/voucher/explain.vue"], resolve);
const voucherDetail = resolve =>
  require(["@/views/voucher/detail.vue"], resolve);
const xuefulanIndex = resolve =>
  require(["@/views/xuefulan/index.vue"], resolve);
const loading = require("@/components/mb-loading.vue");
const follow = resolve => require(["@/components/follow.vue"], resolve);
const debug = resolve => require(["@/debug.vue"], resolve);
const mooring = resolve => require(["@/views/mooring.vue"], resolve);
const baoLide = resolve => require(["@/views/baoLide.vue"], resolve);

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/register",
      name: "register",
      component: register
    },
    {
      path: "/mooring",
      name: "mooring",
      component: mooring
    },
    {
      path: "/home",
      name: "home",
      component: home
    },
    {
      path: "/index",
      name: "index",
      component: index
    },
    {
      path: "/index/:type",
      component: index
    },
    {
      path: "/agreement",
      name: "agreement",
      component: agreement
    },

    {
      path: "/mine/voucher",
      name: "mineVoucher",
      component: mineVoucher
    },
    {
      path: "/",
      component: index
    },
    {
      path: "/order/done",
      name: "doneOrder",
      component: doneOrder
    },
    {
      path: "/order/done/mooring",
      name: "mooring",
      component: mooring
    },
    {
      path: "/order/done/baoLide",
      name: "baoLide",
      component: baoLide
    },
    {
      path: "/baoLide",
      name: "baoLide",
      component: baoLide
    },
    {
      // 避免路由跳转带来闪屏增加路由
      path: "/order/done/chevrolet",
      name: "xuefulanIndex",
      component: xuefulanIndex
    },
    {
      path: "/order/done/:type",
      name: "doneOrder",
      component: doneOrder
    },
    {
      //保留路由(涉及支付、模版消息)
      path: "/detail/:id",
      name: "orderDetail",
      component: orderDetail
    },
    {
      path: "/order/score",
      name: "scorePage",
      component: scorePage
    },
    {
      path: "/voucher/use/:price",
      name: "useVoucher",
      component: useVoucher
    },
    {
      path: "/voucher/explain/:token",
      name: "voucherExplain",
      component: voucherExplain
    },
    {
      path: "/voucher/detail/:token",
      name: "voucherDetail",
      component: voucherDetail
    },
    {
      path: "/xuefulan/index",
      name: "xuefulanIndex",
      component: xuefulanIndex
    },
    {
      path: "/debug",
      name: "debug",
      component: debug
    },
    {
      path: "/loading",
      name: "loading",
      component: loading
    },
    {
      path: "/follow",
      name: "follow",
      component: follow
    },
    {
      path: "*",
      name: "index",
      component: index
    }
  ]
});
//全局钩子
router.beforeEach((to, form, next) => {
  //统计代码
  if (to.path.indexOf("/detail") > -1) {
    ga("send", "pageview", "/detail");
  } else {
    if (to.query && to.query.from) {
      ga("send", "pageview", to.fullPath);
    } else {
      ga("send", "pageview", to.path);
    }
  }
  // 测试配置
  if (to.query.e && to.query.e == "t") {
    localStorage.OpenId = "oXanAvueZJjlVWFlQoScAxav0Cvs";
    // next()
  }
  if (to.query.Scen_str) {
    localStorage.Scen_str = to.query.Scen_str;
  }
  if (to.query.s) {
    localStorage.s = to.query.s;
  }

  const path = /^#(\/[^\?\=\&]*)/.exec(location.hash)
    ? /^#(\/[^\?\=\&]*)/.exec(location.hash)[1]
    : to.path;

  if (window.location.href.indexOf("/#") >= 0) {
    window.location.href = window.location.href.replace("/#", "");
  }

  //通过code换取openid
  const code =
    typeof to.query.code == "string" || typeof to.query.code == "undefined"
      ? to.query.code
      : to.query.code[0];
  if (to.query.code) {
    axios.get(`openid?code=${code}`).then(response => {
      if (response.data.errcode == 0 && response.data.openid) {
        localStorage.OpenId = response.data.openid;
        // 通过openid换取用户信息
        axios
          .get(`openid/info?type=1&openid=${response.data.openid}`)
          .then(response => {
            //已注册用户
            if (response.data.errcode == 0) {
              localStorage.user = JSON.stringify(response.data.data);
              next();
            } else {
              //未注册用户
              if (to.path.indexOf("/home") > -1) {
                next({
                  path: "/register"
                });
              }
            }
            next();
          });
      } else {
        const url =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxcdcdb6fe90c3615f&redirect_uri=https://node.chezhentong.com/m" +
          path +
          "&response_type=code&scope=snsapi_base&state=0#wechat_redirect";
        location.replace(url);
      }
    });
  } else {
    //无code有openid，获取用户信息
    if (localStorage.OpenId && localStorage.OpenId != "") {
      axios
        .get(`openid/info?type=1&openid=${localStorage.OpenId}`)
        .then(response => {
          //已注册用户
          if (response.data.errcode == 0) {
            localStorage.user = JSON.stringify(response.data.data);
          } else {
            //未注册用户
            if (to.path.indexOf("/home") > -1) {
              next({
                path: "/register"
              });
            }
          }
          next();
        });
    } else {
      //无code，无openid
      const url =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxcdcdb6fe90c3615f&redirect_uri=https://node.chezhentong.com/m" +
        path +
        "&response_type=code&scope=snsapi_base&state=0#wechat_redirect";
      location.replace(url);
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js